import { createCustomEnum } from "./customEnum";

export type ProcessorTypesKeys =
	| "fiserv_omaha_fsp"
	| "tsys"
	| "fiserv_north"
	| "fiserv_omaha_retail"
	| "elavon"
	| "payment_advisors"
	| "fiserv_concord"
	| "evo"
	| "powerpay"
	| "mbn"
	| "cardflex"
	| "transfirst"
	| "bankcard_usa"
	| "nab"
	| "fiserv_canada"
	| "legacy_processor"
	| "payments_360";

export const ProcessorTypes = createCustomEnum({
	Payments360: {
		name: "payments_360",
		value: 0,
		displayName: "360 Payments",
	},
	BankcardUsa: {
		name: "bankcard_usa",
		value: 1,
		displayName: "Bankcard USA",
	},
	Cardflex: {
		name: "cardflex",
		value: 2,
		displayName: "Cardflex",
	},
	Elavon: {
		name: "elavon",
		value: 3,
		displayName: "Elavon",
	},
	Evo: {
		name: "evo",
		value: 4,
		displayName: "Evo",
	},
	FiservCanada: {
		name: "fiserv_canada",
		value: 5,
		displayName: "Fiserv Canada",
	},
	FiservConcord: {
		name: "fiserv_concord",
		value: 6,
		displayName: "Fiserv Concord",
	},
	FiservNorth: {
		name: "fiserv_north",
		value: 7,
		displayName: "Fiserv North",
	},
	FiservOmahaFSP: {
		name: "fiserv_omaha_fsp",
		value: 8,
		displayName: "Fiserv Omaha FSP",
	},
	FiservOmahaRetail: {
		name: "fiserv_omaha_retail",
		value: 9,
		displayName: "Fiserv Omaha Retail",
	},
	LegacyProcessor: {
		name: "legacy_processor",
		value: 10,
		displayName: "Legacy Processor",
	},
	MBN: {
		name: "mbn",
		value: 11,
		displayName: "MBN",
	},
	NorthAmericaBankcard: {
		name: "nab",
		value: 12,
		displayName: "North America Bankcard (NAB)",
	},
	PaymentAdvisors: {
		name: "payment_advisors",
		value: 13,
		displayName: "Payment Advisors",
	},
	Powerpay: {
		name: "powerpay",
		value: 14,
		displayName: "Powerpay",
	},
	Transfirst: {
		name: "transfirst",
		value: 15,
		displayName: "Transfirst",
	},
	TSYS: {
		name: "tsys",
		value: 16,
		displayName: "TSYS",
	},
});
